import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NonMembersComponent } from './non-members.component';
import { Shell } from '@app/shell/shell.service';
import { AccessGuard } from '@app/@shared/guards/access.guard';
import { AccessType } from '@app/@shared/enums/access-types.enum';
import { NonMemberComponent } from '@app/areas/non-members/components/non-member/non-member.component';
import { NonMemberModuleRouteResolver, NonMemberRouteResolver } from '@app/areas/non-members/resolvers';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':locationId/non-members',
      component: NonMembersComponent,
      canActivate: [AccessGuard],
      data: { title: 'Non-Members', requiredAccessTypes: [AccessType.ConsumerAccess] },
      resolve: { message: NonMemberModuleRouteResolver },
    },
    {
      path: ':locationId/non-members/:consumerId',
      component: NonMemberComponent,
      canActivate: [AccessGuard],
      data: { title: 'Non-Members', requiredAccessTypes: [AccessType.ConsumerAccess] },
      resolve: { data: NonMemberModuleRouteResolver, message: NonMemberRouteResolver },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NonMembersRoutingModule {}
